import FeedDataType from "./FeedDataType";
var integrations = [
    {
        "provider": "CAT",
        "feedDataType": FeedDataType.TdsV2Cat,
        "url": "https://services.cat.com/telematics/iso15143/fleet/1",
        "refreshInSeconds": 3600
    },
    {
        "provider": "CAT",
        "feedDataType": FeedDataType.TdsV2CatEntraId,
        "url": "https://services.cat.com/telematics/iso15143/fleet/1",
        "refreshInSeconds": 3600
    },
    {
        "provider": "Liebherr",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://www.lidatexternal.liebherr.com/LidatExternal/Service.svc/aemp/fleet",
        "refreshInSeconds": 3600
    },
    {
        "provider": "Volvo",
        "feedDataType": FeedDataType.TdsV2VolvoCareTrack,
        "url": "https://api-awe.volvo.com/vce/cs/aemp/v1/Fleet/1",
        "refreshInSeconds": 3600,
        "oauth2url": "https://login.microsoftonline.com/f25493ae-1c98-41d7-8a33-0be75f5fe603/oauth2/v2.0/token"
    },
    {
        "provider": "Wirtgen",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://fmi.witos.wirtgen-group.com/webservices/fmi_rest",
        "refreshInSeconds": 3600
    },
    {
        "provider": "Hitachi",
        "feedDataType": FeedDataType.TdsV2Hitachi,
        "url": "https://www.globaleservice.com/TelematicsAPI/api/ISO-15143-3/daily/v1/Fleet/1",
        "refreshInSeconds": 3600
    },
    {
        "provider": "Staad",
        "feedDataType": FeedDataType.TdsV2Staad,
        "url": "https://staad.app/api/AEMP/v1/1",
        "refreshInSeconds": 3600
    }
];
if (window.debug) {
    // The feed generator is only used for testing purposes, don't show this option for customers.
    integrations.push({
        "provider": "FEED GENERATOR",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://feed-generator.azurewebsites.net/tds12?customer={organisationId}",
        "refreshInSeconds": 3600
    });
}
export default integrations;
